main.navigation = (function () {
    var header = document.querySelector('.c-header--primary, .c-header--image');
    var headerHeight;
    var headerOffset = 60;
    var menu = document.getElementsByClassName('js-nav-menu')[0];
    var toggle = document.getElementsByClassName('js-nav-toggle')[0];

    var init = function () {
        _addToggleHandler();

        if (!header) {
            return;
        }

        _setHeaderHeight();
        _setHeaderColor();

        window.addEventListener('resize', function(){
            _setHeaderHeight();
            _setHeaderColor();
        });

        window.addEventListener('scroll', function(){
            _setHeaderColor();
        });
    };

    var _setHeaderHeight = function() {
        headerHeight = header.offsetHeight;
    };

    var _setHeaderColor =  function() {
        if (main.utils.viewport().width < 768) {
            header.classList.remove('is-inverted');
            return;
        }

        var scrollPositionTrigger = headerHeight;

        if (header.classList.contains('c-header--image')) {
            scrollPositionTrigger = headerHeight - headerOffset;
        }

        if (window.pageYOffset > scrollPositionTrigger) {
            header.classList.add('is-inverted');
        } else {
            header.classList.remove('is-inverted');
        }
    };

    var _addToggleHandler = function () {
        toggle.addEventListener('click', function () {
            menu.classList.toggle('is-active');
            toggle.classList.toggle('is-active');
        });
    };

    return {
        init: init
    };
})();
